/**
 * Stripe Subscriptions
 * Default purchase option: One-time purchase
 *
 * Keeps the one-time option selected while Stripe initializes.
 * Stops interfering immediately after a real customer interaction.
 */
(() => {
  const WIDGET_SELECTOR = '.subscription-selector';
  const ONE_TIME_SELECTOR =
    'input[type="radio"][value="onetime"]';

  const RADIO_SELECTOR =
    '.purchase-type-selector input[type="radio"]';

  let customerHasChosen = false;
  let applyingDefault = false;

  function getWidgets() {
    return document.querySelectorAll(WIDGET_SELECTOR);
  }

  function selectOneTime(widget) {
    if (
      customerHasChosen ||
      applyingDefault ||
      !widget
    ) {
      return;
    }

    const oneTimeRadio = widget.querySelector(
      ONE_TIME_SELECTOR
    );

    if (!oneTimeRadio || oneTimeRadio.checked) {
      return;
    }

    applyingDefault = true;

    /*
     * Clicking is important because Stripe must update
     * both the visible radio and its selling-plan state.
     */
    oneTimeRadio.click();

    window.setTimeout(() => {
      applyingDefault = false;
    }, 50);
  }

  function enforceDefault() {
    if (customerHasChosen) {
      return;
    }

    getWidgets().forEach(selectOneTime);
  }

  /*
   * A trusted event means an actual customer clicked,
   * tapped, or used the keyboard.
   */
  document.addEventListener(
    'click',
    (event) => {
      const radio = event.target.closest?.(
        RADIO_SELECTOR
      );

      if (
        radio &&
        event.isTrusted &&
        !applyingDefault
      ) {
        customerHasChosen = true;
      }
    },
    true
  );

  document.addEventListener(
    'change',
    (event) => {
      if (
        event.target.matches?.(RADIO_SELECTOR) &&
        event.isTrusted &&
        !applyingDefault
      ) {
        customerHasChosen = true;
      }
    },
    true
  );

  document.addEventListener(
    'keydown',
    (event) => {
      if (
        event.target.matches?.(RADIO_SELECTOR) &&
        event.isTrusted
      ) {
        customerHasChosen = true;
      }
    },
    true
  );

  function start() {
    enforceDefault();

    /*
     * Stripe may replace or update its widget several
     * seconds after the page first appears.
     */
    const observer = new MutationObserver(() => {
      enforceDefault();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: [
        'checked',
        'class',
        'style'
      ]
    });

    /*
     * Also check the radio property itself because changing
     * element.checked does not always create a DOM mutation.
     */
    const interval = window.setInterval(() => {
      if (customerHasChosen) {
        window.clearInterval(interval);
        observer.disconnect();
        return;
      }

      enforceDefault();
    }, 250);

    /*
     * Stripe should be fully initialized by this point.
     * Stop watching eventually to avoid a permanent timer.
     */
    window.setTimeout(() => {
      window.clearInterval(interval);
      observer.disconnect();
    }, 30000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      start,
      { once: true }
    );
  } else {
    start();
  }
})();
